import React from 'react';
import './ErrorPage.css';

/**
 * [CurveBeamAI] Displays status or error messages during app initialization.
 * Mirrors develop branch behavior: used for "Pending DMP Access Token validation...",
 * "App initializing...", and error messages.
 */
const ErrorPage: React.FC<{ message?: string }> = ({ message = 'Loading...' }) => {
  return (
    <div className="error-page">
      <h4>{message}</h4>
    </div>
  );
};

export default ErrorPage;
